"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUILDER_CONTEXT = exports.QUESTION_TYPE = void 0;
var QUESTION_TYPE = {
  multipleChoice: 1,
  trueFalse: 2,
  checkbox: 3,
  stackRank: 4,
  title: 5,
  paragraph: 6,
  textField: 7,
  starRating: 8,
  ratingScale: 9,
  multipleText: 10,
  constantSum: 11,
  dropdownList: 12,
  video: 13,
};
exports.QUESTION_TYPE = QUESTION_TYPE;
var BUILDER_CONTEXT = {
  new: 'new',
  edit: 'edit'
};
exports.BUILDER_CONTEXT = BUILDER_CONTEXT;